import { render, staticRenderFns } from "./StaffRegisterPage.vue?vue&type=template&id=301b7581&"
import script from "./StaffRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./StaffRegisterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports